import React from 'react';
import zxcvbn from 'zxcvbn';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import FormHelperText from '@material-ui/core/FormHelperText';
import strongPasswordDialog from '../shared/StrongPasswordDialog';

const styles = () => ({
  passwordMeter: {
    height: 10,
    width: '100%',
    backgroundColor: '#f5f5f5',
    borderRadius: 5,
    boxShadow: 'inset 0 1px 2px rgb(0 0 0 / 10%)',
  },
  passwordMeterProgress: {
    height: 10,
    borderRadius: 5,
    transition: 'width .6s ease',
  },
  passwordMeterText: {
    fontSize: 14,
    margin: '10px 0 0',
  },
});

class PasswordMeter extends React.Component {
  constructor(props) {
    super(props);

    this.onStrongPasswordDialogClick = this.onStrongPasswordDialogClick.bind(this);
  }

  onStrongPasswordDialogClick(event) {
    event.preventDefault();

    strongPasswordDialog();
  }

  render() {
    const {
      classes,
      t,
      password,
    } = this.props;

    const result = zxcvbn(password);
    let score = result.score;
    if (password.length < 12) {
      score = 0;
    }

    return (
      <div className="password-meter">
        <div className={classes.passwordMeter}>
          <div
            className={classes.passwordMeterProgress}
            style={{
              width: (score * 25) + '%',
              backgroundColor: score < 2
                ? '#d9534f'
                : (score < 3
                    ? '#f0ad4e'
                    : '#5cb85c'
                )
            }}
          >
          </div>
        </div>
        {password && (
          <p className={classes.passwordMeterText}>{t('Strength')}: <b>{score < 2
            ? t('Weak')
            : (score < 3
              ? t('Average')
              : (score < 4
                ? t('Good')
                : t('Strong')
              )
            )
          }</b></p>
        )}
        <FormHelperText className={classes.formHelperText}>
          <a href="#" onClick={this.onStrongPasswordDialogClick}>
            {t('What makes a strong password?')}
          </a>
        </FormHelperText>
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(withTranslation()(PasswordMeter)));
